module.exports = __webpack_public_path__ + "img/customer-tips.800adadb.svg";